/**
 * Changes the input field of the form
 *
 * @return {object}    An action object with a type of REQUEST_TOKEN
 */
import {
  VALIDATE_POLICY_INFO,
  SET_TOKEN,
  VALUE_CHANGED,
  TOGGLE_MODAL,
  VALIDATE_VERIFICATION_CODE,
  SET_REQUIRE_VERIFICATION_CODE,
  SET_USER_NAME,
  RESET_AUTHENTICATION_INFO,
  LOADING,
  SET_PURCHASE_DATE,
} from './constants';
import { API_FAIL } from '../App/constants';

export function validatePolicyInfo() {
  return {
    type: VALIDATE_POLICY_INFO,
  };
}

export function setAuthenticationToken(authToken) {
  return {
    type: SET_TOKEN,
    authToken,
  };
}

export function setRequireVerificationCode(require) {
  return {
    type: SET_REQUIRE_VERIFICATION_CODE,
    require,
  };
}

export function validateVerificationCode() {
  return {
    type: VALIDATE_VERIFICATION_CODE,
  };
}

export function handleFormDataChange(propertyName, value) {
  return {
    type: VALUE_CHANGED,
    propertyName,
    value,
  };
}

export function toggleModalError() {
  return {
    type: TOGGLE_MODAL,
  };
}

export function getTokenError(error) {
  return {
    type: API_FAIL,
    error,
  };
}

export function setUserName(name) {
  return {
    type: SET_USER_NAME,
    name,
  };
}

export function resetLoginInfo() {
  return {
    type: RESET_AUTHENTICATION_INFO,
  };
}

export function loading(status) {
  return {
    type: LOADING,
    status,
  };
}

export function setPurchaseDate(purchaseDate) {
  return {
    type: SET_PURCHASE_DATE,
    purchaseDate,
  };
}



// WEBPACK FOOTER //
// ./app/containers/Login/actions.js